import React from 'react'
import PropTypes from 'prop-types'
import DebouncedInput from '../../../../molecules/DebouncedInput'
import { useDDPReportIndexedDBContext } from './DDPReportIndexedDBContext'

/**
 * Composable search component for IndexedDB-backed reports
 * Must be used within <DDPReportIndexedDBProvider>
 * Triggers re-query of IndexedDB on search
 */
function DDPReportIndexedDBSearch ({ placeholder, className, style }) {
  const { globalFilter, setGlobalFilter } = useDDPReportIndexedDBContext()

  return (
    <DebouncedInput
      value={globalFilter}
      placeholder={placeholder || 'Search'}
      onChange={setGlobalFilter}
      className={className}
      style={style}
    />
  )
}

DDPReportIndexedDBSearch.propTypes = {
  placeholder: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object
}

export default DDPReportIndexedDBSearch
